import { render } from "./TrailerTimeline.vue?vue&type=template&id=4573ef08&scoped=true"
import script from "./TrailerTimeline.vue?vue&type=script&lang=ts"
export * from "./TrailerTimeline.vue?vue&type=script&lang=ts"

import "./TrailerTimeline.vue?vue&type=style&index=0&id=4573ef08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4573ef08"

export default script